import * as moment from "moment";

const dateFormat = "DD.MM.YYYY HH:mm";

export const momentToString = (date: moment.Moment) => {
    return date.format(dateFormat);
}

const timeFormat = "HH:mm";

export const momentToTimeString = (date: moment.Moment) => {
    return date.format(timeFormat);
}

const dtoFormat = "YYYY-MM-DD HH:mm:ssZZ"

export const momentToDtoString = (date: moment.Moment) => {
    return date.format();
}

export const dateStringSort = (a: string, b: string) => {
    const aa = moment(a, dateFormat).toISOString();
    const bb = moment(b, dateFormat).toISOString();
    if (aa === bb) {
        return 0;
    }
    return aa > bb ? 1 : -1;
}



// WEBPACK FOOTER //
// ./src/utils/dateUtilities.ts